<template>
  <div>
    <portal ref="portal">
      <div slot="portal-panel">
        <div class="background" @click="closeSlide">
          <div v-if="copyList.length > 0" class="slide">
            <slider
              :active-index="activeIndex"
              :tmp-index="tmpIndex"
              :width="width"
              :size="size"
              :option="option"
              @updateIndex="onUpdateIndex"
            >
              <slider-item
                v-for="(item, i) in copyList"
                :key="item.unique_id"
                :index="i"
                :active-index="activeIndex"
                :tmp-index="tmpIndex"
                :width="width"
                :size="size"
                :option="option"
                @click.stop="tapClick"
                @click.native="closeSlide"
              >
                <img
                  :src="imgFormatFilter(item)"
                  :width="width"
                  ondragstart="return false"
                  @error="imgLoadFail"
                />
              </slider-item>
            </slider>
            <div class="index-box">
              <span class="current">{{ activeIndex + 1 }}</span
              >/{{ size }}
            </div>
          </div>
          <div
            v-if="isShowConfirm"
            class="comfirm"
            @click.stop="handlerSaveImg"
          >
            保存图片
          </div>
        </div>
      </div>
    </portal>
  </div>
</template>
<script>
import {
  imgLoadFail,
  imgFormatFilter,
  downloadPictureToAlbum
} from '@/utils/imgTools'
import Portal from '../common/Portal.vue'
import mixins from '../common/portal.mixin.js'
import Slider from '../Slider/Index.vue'
import SliderItem from '../Slider/Item.vue'
// eslint-disable-next-line camelcase
import { _width } from '@/utils/global'
import { platform } from '@/defines/environment'

export default {
  components: {
    Portal,
    Slider,
    SliderItem
  },
  mixins: [mixins],
  data() {
    return {
      imgArr: [],
      size: 1,
      copyList: [],
      activeIndex: 0,
      tmpIndex: 0,
      isSaveImg: false,
      commonWaterMark: true,
      width: _width,
      option: {
        auto: false,
        loop: true,
        scale: 1,
        spaceBetween: 0,
        allowTouchMove: true,
        appendNum: 1,
        speed: 600,
        delay: 3000,
        preventDefault: true,
        // eslint-disable-next-line camelcase
        startPos: -_width,
        // eslint-disable-next-line camelcase
        endPos: -_width
      }
    }
  },
  computed: {
    isShowConfirm() {
      // eslint-disable-next-line camelcase
      return this.isSaveImg && (platform === 'ios' || platform === 'android')
    }
  },
  methods: {
    imgLoadFail,
    imgFormatFilter(item) {
      return this.commonWaterMark ? imgFormatFilter(item, this.width * 2) : item
    },
    onUpdateIndex(info) {
      this.activeIndex = info.index
      this.tmpIndex = info.tmpIndex
    },
    closeSlide() {
      this.close()
    },
    tapClick() {
      console.log('tapClick')
    },
    handlerSaveImg() {
      const url = this.imgArr[this.activeIndex]
      downloadPictureToAlbum(url, res => {
        if (res) {
          if (res.ret === 1) {
            this.$toast('图片保存成功')
          } else {
            this.$toast('图片保存失败')
          }
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.background {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  z-index: 1;

  background-color: black;
}
.slide {
  position: absolute;
  top: 50%;
  left: 0;

  z-index: 2;

  transform: translate(0, -50%);

  width: 100%;
  max-height: 400px;

  overflow: hidden;
  .slider-wrapper {
    overflow: hidden;

    white-space: nowrap;
    .slider-item {
      display: inline-block;

      overflow: hidden;

      background-color: #fff;

      background-repeat: no-repeat;

      background-position: center;

      font-size: 0;

      text-align: center;
      vertical-align: top;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .index-box {
    position: absolute;
    right: 0.3rem;
    bottom: 0.3rem;

    transform: translate3d(0, 0, 0);

    width: 36px;
    height: 36px;

    padding-right: 2px;

    background-color: #999999;

    border-radius: 100%;

    font-size: 12px;
    line-height: 36px;
    text-align: center;
    color: #fff;
    .current {
      display: inline-block;

      padding: 0 2px;

      font-size: 18px;
      vertical-align: bottom;
    }
  }
}
.comfirm {
  position: absolute;
  right: 0.3rem;
  bottom: 0.4rem;

  width: 2.2rem;
  height: 0.88rem;

  border-radius: 0.46rem;
  border: 1px solid #fff;

  font-size: 0.32rem;
  line-height: 0.88rem;
  text-align: center;
  color: #fff;
}
</style>
